import { createI18n } from 'vue-i18n';
import type { Ref } from 'vue';

import uz from './locales/uz';

export type MessageSchema = typeof uz;
export type SupportedLocale = 'uz';

export const DEFAULT_LOCALE: SupportedLocale = 'uz';
export const SUPPORTED_LOCALES: SupportedLocale[] = ['uz'];

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    uz,
  },
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
});

export function setLocale(locale: SupportedLocale): void {
  (i18n.global.locale as Ref<string>).value = locale;
  document.documentElement.setAttribute('lang', locale);
}
